import {
  GET_SIGNET_LIST,
  GET_SIGNET_LIST_START,
  GET_SIGNET_LIST_ERROR,
  GET_SIGNET_LIST_FILTER,
  GET_SIGNET_LIST_FILTER_START,
  GET_SIGNET_LIST_FILTER_ERROR,
  UPDATE_SIGNET_STATUS,
  UPDATE_SIGNET_STATUS_START,
  UPDATE_SIGNET_STATUS_ERROR,
  GET_SIGNET,
  GET_SIGNET_START,
  GET_SIGNET_ERROR,
  GET_SIGNET_BY_CLIENT_LIST,
  GET_SIGNET_BY_CLIENT_LIST_START,
  GET_SIGNET_BY_CLIENT_LIST_ERROR,
  VALIDATE_REQUEST_FOR_SIGNET_STATUS,
  VALIDATE_REQUEST_FOR_SIGNET_STATUS_START,
  VALIDATE_REQUEST_FOR_SIGNET_STATUS_ERROR,
} from '../actions/types';

const initialState = {
  signetList: [],
  signet: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const findAllSignetPageableStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllSignetPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    signetList: action.payload[0],
  };
};

const findAllSignetPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllSignetFilterPageableStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllSignetFilterPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    signetList: action.payload[0],
  };
};

const findAllSignetFilterPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateSignetStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};
const updateSignetError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateSignet = (state, action) => {
  return {
    ...state,
    loading: false,
    signetList: state.signetList.map((signet) =>
      signet.id === action.payload.id ? action.payload : signet
    ),
    signet: action.payload,
    error: undefined,
  };
};

const findSignetById = (state, action) => {
  return {
    ...state,
    loading: false,
    signet: action.payload,
    error: undefined,
  };
};

const findSignetByIdStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};
const findSignetByIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const validRequestForSignetStatusStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};

const validRequestForSignetStatus = (state, action) => {
  return {
    ...state,
    signet: action.payload,
    error: undefined,
  };
};

const validRequestForSignetStatusError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SIGNET_LIST_START:
    case GET_SIGNET_BY_CLIENT_LIST_START:
      return findAllSignetPageableStart(state);
    case GET_SIGNET_LIST:
    case GET_SIGNET_BY_CLIENT_LIST:
      return findAllSignetPageable(state, action);
    case GET_SIGNET_LIST_ERROR:
    case GET_SIGNET_BY_CLIENT_LIST_ERROR:
      return findAllSignetPageableError(state, action);
    case GET_SIGNET_LIST_FILTER_START:
      return findAllSignetFilterPageableStart(state);
    case GET_SIGNET_LIST_FILTER:
      return findAllSignetFilterPageable(state, action);
    case GET_SIGNET_LIST_FILTER_ERROR:
      return findAllSignetFilterPageableError(state, action);
    case UPDATE_SIGNET_STATUS:
      return updateSignet(state, action);
    case UPDATE_SIGNET_STATUS_START:
      return updateSignetStart(state);
    case UPDATE_SIGNET_STATUS_ERROR:
      return updateSignetError(state, action);
    case GET_SIGNET:
      return findSignetById(state, action);
    case GET_SIGNET_START:
      return findSignetByIdStart(state);
    case GET_SIGNET_ERROR:
      return findSignetByIdError(state, action);
    case VALIDATE_REQUEST_FOR_SIGNET_STATUS:
      return validRequestForSignetStatus(state, action);
    case VALIDATE_REQUEST_FOR_SIGNET_STATUS_START:
      return validRequestForSignetStatusStart(state);
    case VALIDATE_REQUEST_FOR_SIGNET_STATUS_ERROR:
      return validRequestForSignetStatusError(state, action);

    default:
      return state;
  }
}
